import { render, staticRenderFns } from "./DibsFees.vue?vue&type=template&id=37c89887"
import script from "./DibsFees.vue?vue&type=script&lang=js"
export * from "./DibsFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports